import { getWritingScore, getLatestScore } from '../../app/score/actions/score';
import { EssayScoreResult, EssayScore } from '../../app/score/types/score';
import { StructuredEssayData, WritingTaskType } from '@/types/writing';
import {
  QuestionType,
  QuestionNote,
  Task1Type,
  VisualType,
} from '@/types/task-bank';

export const scoreService = {
  async getLatest(
    taskId: string | null
  ): Promise<(EssayScore & { timestamp?: string }) | null> {
    if (!taskId) return null;
    try {
      const result = await getLatestScore(taskId);
      return result;
    } catch (error) {
      console.error('[ScoreService] Error calling getLatestScore:', error);
      throw new Error(
        'Failed to load existing score. ' +
          (error instanceof Error ? error.message : '')
      );
    }
  },

  async fetchNew(
    userId: string,
    currentEssayId: string,
    prompt: string,
    essayData: StructuredEssayData,
    taskType: WritingTaskType = 'task2',
    questionType?: QuestionType | '',
    questionNote?: QuestionNote | '',
    task1Type?: Task1Type,
    visualType?: VisualType
  ): Promise<EssayScoreResult> {
    try {
      const result = await getWritingScore(
        userId,
        currentEssayId,
        prompt,
        essayData,
        taskType,
        questionType,
        questionNote,
        task1Type,
        visualType
      );
      return result;
    } catch (error: unknown) {
      console.error(
        '[ScoreService] Error calling getWritingScore action:',
        error
      );
      return {
        taskResponse: { band: 0, feedback: '' },
        coherenceAndCohesion: { band: 0, feedback: '' },
        lexicalResource: { band: 0, feedback: '' },
        grammaticalRangeAndAccuracy: { band: 0, feedback: '' },
        overallBand: 0,
        improvementAdvice: [],
        wordCount: 0,
        status: 'updated',
        error:
          'An unexpected server-side error occurred while fetching score. ' +
          (error instanceof Error ? error.message : ''),
      };
    }
  },
};
